import React from "react";

interface ButtonProps {
  onClick: any;
  label: string;
  chosen?: boolean;
  children?: React.ReactNode
}

const basicClassName = 'border-transparent hover:border-blue-400 hover:text-blue-400 text-white'
const chosenClassName = 'border-blue-400 text-blue-400'

const Button = ({
  onClick,
  label,
  chosen,
  children
}: ButtonProps): JSX.Element => {
  const className = chosen ? chosenClassName : basicClassName

  return (
    <div
      className={`${className} py-2 px-4 rounded-md border flex items-center justify-center bg-black/30 uppercase hover:cursor-pointer`}
      onClick={onClick}
      aria-label={label}
    >
      {children}
    </div>
  );
};

export default Button;
